module.exports = __webpack_public_path__ + "static/media/6S.c99b0f04.png";